/**
 * Renders the navigation alerts module.
 *
 * - Gets references to key DOM elements.
 * - Defines helper functions for setting/getting cookies.
 * - Defines cookieCreator() to set cookie on form submit.
 * - Defines newsletterHeaderBuilder() to show/hide elements based on cookie value.
 * - Initializes by calling newsletterHeaderBuilder().
 */
const alertsNavRender = (function () {
  const navAlertsIconBtn = document.querySelector('[data-name="toggle-button--nav-alerts"]');
  // const navAlertsPopup = document.querySelector('[data-name="nav-alert-popup-popup-form"]');
  const navAlertsPopupNotification = document.querySelector('[data-name="nav-alerts-icon-notification"]');
  const navAlertsPopupContentOriginal = document.querySelector('[data-name="nav-alert-popup-content-original"]');
  const navAlertsPopupContentCustom = document.querySelector('[data-name="nav-alert-popup-content-custom"]');

  function cookieCreator() {
    setCookie("notificator-header", "subscribed", 2147483647);
    navAlertsPopupNotification.classList.remove("Visible");
    navAlertsIconBtn.classList.remove("Visible");
    newsletterHeaderBuilder();
  }

  function cookieCreatorNotificationDot() {
    setCookie("notificator-header-dot", "seen", 2147483647);
    hideDotAfterSidebarOpen();
  }

  window.addEventListener("klaviyoForms", function (e) {
    if ((e.detail.type == 'submit' && e.detail.formId == "VfX4c9") || (e.detail.type == 'submit' && e.detail.formId == "TBKeb5")) {
      const formId = e.detail.formId;
      cookieCreator();
      _subscribeForm(formId);
    }
  });

  // navAlertsPopup.addEventListener("submit", cookieCreator);

  function hideDotAfterSidebarOpen() {
    if (getCookie("notificator-header") !== "subscribed" && (getCookie("notificator-header-dot") !== "seen")) {
      navAlertsPopupNotification.classList.add("visible");
      navAlertsPopupNotification.classList.remove("hidden");
    } else {
      navAlertsPopupNotification.classList.add("hidden");
      navAlertsPopupNotification.classList.remove("visible");
    }
  }
  hideDotAfterSidebarOpen();

  navAlertsIconBtn.addEventListener('click', cookieCreatorNotificationDot);

  // Build visibility of the newsletter header popup module
  function newsletterHeaderBuilder() {
    if (getCookie("notificator-header") !== "subscribed") {
      // navAlertsPopupNotification.classList.remove("hidden");
      navAlertsIconBtn.classList.remove("hidden");
      // navAlertsPopupNotification.classList.add("visible");
      navAlertsIconBtn.classList.add("visible");
    } else {
      navAlertsPopupContentOriginal.classList.remove("visible");
      navAlertsPopupContentCustom.classList.add("visible");
      navAlertsPopupNotification.classList.add("hidden");
      navAlertsIconBtn.classList.add("hidden");
      navAlertsPopupNotification.classList.remove("visible");
      navAlertsIconBtn.classList.remove("visible");
    }
  }
  newsletterHeaderBuilder();
})();
